/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    driverLogsIdSelected:0,
    defaultDataDriverLogs:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_DRIVER_LOGS_ID = 'SET_DRIVER_LOGS_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setDriverLogsId = (payload) => ({
  type: SET_DRIVER_LOGS_ID,
  payload,
})
export const setDefaultDataDriverLogs = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_DRIVER_LOGS_ID:
        return {
          ...state,
          driverLogsIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataDriverLogs: payload,
          }
     default:
       return state
   }
 }
 